<script>
import { mapState, mapActions } from 'vuex'
import Store from '@/store/store'

const commonRules = {
  'required-field': {
    required: true,
    message: 'To pole jest wymagane.',
    trigger: 'blur'
  }
}

export default {
  name: 'login',
  store: Store,
  props: [ 'nextUrl' ],
  data () {
    return {
      loginForm: {
        email: null,
        password: null
      },
      rules: {
        email: [
          commonRules[ 'required-field' ],
          { type: 'email', message: 'Niepoprawny format adresu email.' }
        ]
      }
    }
  },
  computed: {
    ...mapState([
      'loggingIn',
      'loginError',
      'loginSuccessful'
    ])
  },
  methods: {
    ...mapActions([
      'aLogin',
      'aUserAccountPasswordResetRequest'
    ]),
    handleCreateAccount: function () {
      this.$router.push({ name: 'user-account-create' })
    },
    handlePasswordReset: function (formName) {
      this.$refs[ formName ].validate((valid, validated) => {
        if (valid) {
          this.aUserAccountPasswordResetRequest(this[ formName ].email)
        }
        return false
      })
    },
    handleLogin: function (formName) {
      this.$refs[ formName ].validate((valid, validated) => {
        if (valid) {
          this.aLogin({
            username: this[ formName ].email,
            password: this[ formName ].password,
            vm: this
          })
        }
        return false
      })
    }
  }
}
</script>

<template>
  <div>
    <el-row :gutter="20">
      <el-col
        :span="12"
        :offset="6"
      >
        <h1>Logowanie do serwisu</h1>
        <el-form
          ref="loginForm"
          label-width="120px"
          :model="loginForm"
          :rules="rules"
        >
          <el-card class="box-card">
            <el-form-item label="e-mail" prop="email">
              <el-input
                placeholder="nazwa@domena.pl"
                v-model="loginForm.email"
                type="email"
              ></el-input>
            </el-form-item>
            <el-form-item label="hasło" prop="password">
              <el-input
                placeholder="password"
                type="password"
                v-model="loginForm.password"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="handleLogin('loginForm')"
              >
                Zaloguj
              </el-button>
              <el-collapse style="margin-top: 1rem;">
                <el-collapse-item
                  title="Zapomniałem hasła..."
                  name="reset"
                >
                  <div>
                    Wprowadź poprawnie w powyższy formularz swój e-mail, który
                    używasz do logowania się do serwisu, a następnie
                    użyj przycisku <strong>Resetuj hasło</strong>. Na podany
                    adres otrzymasz widomość z linkiem pozwalającym na wykonanie procedury
                    resetu hasła.
                  </div>
                  <el-button
                    style="float: right; margin: .5rem 0;"
                    @click="handlePasswordReset('loginForm')"
                  >
                    Resetuj hasło
                  </el-button>
                </el-collapse-item>
                <el-collapse-item
                  title="Nie mam jeszcze konta!"
                  name="register"
                >
                  <div>
                    Nie posiadasz jeszcze konta w naszym serwisie? Przejdź do formularza
                    rejestracji korzystając z przycisku 'Załóż konto'.
                  </div>
                  <el-button
                    @click="handleCreateAccount"
                    style="float: right; margin: .5rem 0;"
                  >
                    Załóż konto
                  </el-button>
                </el-collapse-item>
              </el-collapse>
            </el-form-item>
          </el-card>
        </el-form>

      </el-col>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/login.vue